function moveOutOfStockToBottom(grid) {
  if (!grid) return;

  // On trie les <li> (ou enfants directs du grid) pour garder la grille intacte
  const items = Array.from(grid.children).filter((item) =>
    item.querySelector('[data-available]')
  );

  if (!items.length) return;

  const inStock = [];
  const outOfStock = [];

  items.forEach((item) => {
    const el = item.querySelector('[data-available]');
    const available = el && el.dataset.available === 'true';
    (available ? inStock : outOfStock).push(item);
  });

  [...inStock, ...outOfStock].forEach((item) => grid.appendChild(item));
}

(function () {
  function initLoadMore() {
const grid = document.querySelector("#product-grid ul") || document.getElementById("product-grid");

    if (!grid) return;

    // ✅ Tri au chargement initial (même sans bouton)
    moveOutOfStockToBottom(grid);

    const btn = document.querySelector(".load-more-button");
    if (!btn) return;

    let nextUrl = btn.getAttribute("data-next-url");
    let loading = false;

    async function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;

      const originalText = btn.textContent;
      btn.textContent = "Chargement…";
      btn.disabled = true;

      try {
        const res = await fetch(nextUrl, { credentials: "same-origin" });
        if (!res.ok) throw new Error("HTTP " + res.status);

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

       const nextGrid = doc.querySelector("#product-grid ul") || doc.getElementById("product-grid");

        if (!nextGrid) throw new Error("Grid not found");

        // ✅ Prend tous les LI (produits) de la page suivante
        const newItems = Array.from(nextGrid.children).filter(
          (item) => item.tagName === "LI"
        );

        // ✅ Si plus rien à charger -> on cache le bouton
        if (newItems.length === 0) {
          btn.style.display = "none";
          return;
        }

        // Ajoute les nouveaux produits
        newItems.forEach((item) => grid.appendChild(item));

        // Retri après ajout
        moveOutOfStockToBottom(grid);

        // ✅ Mise à jour de nextUrl depuis la page qu'on vient de charger
        const nextBtn = doc.querySelector(".load-more-button");
        if (nextBtn && nextBtn.getAttribute("data-next-url")) {
          nextUrl = nextBtn.getAttribute("data-next-url");
          btn.textContent = originalText;
          btn.disabled = false;
        } else {
          btn.style.display = "none";
        }
      } catch (e) {
        console.error(e);
        btn.style.display = "none";
      } finally {
        loading = false;
      }
    }

    btn.addEventListener("click", loadNext);
  }

  document.addEventListener("DOMContentLoaded", initLoadMore);
})();
